import { FC, useEffect, useState } from 'react';
import { Divider, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import Authentication from './components/Authentication';
import DownloadAccountInformation from './components/DownloadAccountInformation';
import TFA from './components/TFA';
import Metadata from './meta';

// interface AccountSecurityProps {}

const AccountSecurity: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <>
            <Metadata />
            <Typography.Title level={1}>Account Security</Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                Manage security for this account.
            </Typography.Paragraph>
            <Divider />
            <Authentication />
            <Divider />
            <TFA />
            <Divider style={{ marginTop: '1rem' }} />
            <DownloadAccountInformation />
        </>
    );
};

export default AccountSecurity;
